
// const mutations = {

//     SET_MODAL(state, payload) {
//         state.content = payload.content
//         state.hash = Math.random()
//     },

//     SET_MESSAGE(state, payload) {
//         state.content = payload.content
//         state.color = payload.color
//         state.hash = Math.random()
//     }
// }


export default {
    namespaced: true,

    state: {
        content:"",
        color:"",
        hash:"",
        position:"is-top",
        modalContent:"",
        modalHash:"",
        modalAlert: false,
        modalWatchlistAddFund: false,
        modalWatchlistCreateNew: false,
    },

    getters: {

    },

    mutations: {
        SET_MESSAGE(state, payload) {
            state.content = payload.content
            state.color = payload.color
            state.hash = Math.random()
        },
        SET_MODAL(state, title) {
            state.modalContent = title
            state.modalHash = Math.random().toString()
        },
        SET_MODAL_ALERT(state, bool) {
            state.modalAlert = bool;
        },
        SET_MODAL_WATCHLIST_ADD_FUND(state, bool) {
            state.modalWatchlistAddFund = bool;
        },
        SET_MODAL_WATCHLIST_CREATE_NEW(state, bool) {
            state.modalWatchlistCreateNew = bool;
        },
    },

}

